document.addEventListener('DOMContentLoaded', () => {
    initAnimation();
    initModal();
    initMobileReminder();
    initHeaderAndMobile();
    initSlider();
    initAnchors();
    initForm();
    initFAQ();
});

// Animations Functional

function initAnimation() {
  const elements = document.querySelectorAll(".reveal");
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      const animation = el.dataset.anim || "fade-up";
      const delay = el.dataset.delay || 0;

      el.style.animationDelay = delay + "ms";

      requestAnimationFrame(() => {
        el.classList.remove("opacity-0");
        el.classList.add("animate-" + animation);
      });

      obs.unobserve(el);
    });
  }, { threshold: 0.15 });

  elements.forEach(el => observer.observe(el));
}

// Header And Mobile Functional

function initHeaderAndMobile() {
  const header = document.getElementById("site-header");
  const toggleBtn = document.getElementById("mobileToggle");
  const mobileMenu = document.getElementById("mobileMenu");
  const iconBurger = document.getElementById("iconBurger");
  const iconClose = document.getElementById("iconClose");

  if (!header || !toggleBtn || !mobileMenu || !iconBurger || !iconClose) return;

  let isOpen = false;

  window.addEventListener("scroll", () => {
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  });

  const showBurger = () => {
    iconBurger.classList.remove("opacity-0");
    iconBurger.classList.add("opacity-100");

    iconClose.classList.remove("opacity-100");
    iconClose.classList.add("opacity-0");
  };

  const showClose = () => {
    iconBurger.classList.remove("opacity-100");
    iconBurger.classList.add("opacity-0");

    iconClose.classList.remove("opacity-0");
    iconClose.classList.add("opacity-100");
  };

  const openMenu = () => {
    isOpen = true;

    mobileMenu.classList.remove("pointer-events-none");
    mobileMenu.classList.remove("animate-mobile-out");
    mobileMenu.classList.add("animate-mobile-in");

    showClose();
    document.body.classList.add("overflow-hidden");
  };

  const closeMenu = () => {
    isOpen = false;

    mobileMenu.classList.remove("animate-mobile-in");
    mobileMenu.classList.add("animate-mobile-out");

    showBurger();
    document.body.classList.remove("overflow-hidden");

    setTimeout(() => {
      if (!isOpen) {
        mobileMenu.classList.add("pointer-events-none");
      }
    }, 250);
  };

  toggleBtn.addEventListener("click", () => {
    isOpen ? closeMenu() : openMenu();
  });

  mobileMenu.querySelectorAll("a").forEach(link => {
    link.addEventListener("click", closeMenu);
  });
}

// Slider Functional

function initSlider() {
  const swiper = new Swiper('.reviewsSwiper', {
    loop: true,
    speed: 1000,
    spaceBetween: 20,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      }
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

// Modal Functional

function initModal() {

  const modal = document.getElementById("main-modal");
  if (!modal) return;

  const overlay = modal.querySelector(".modal-overlay");
  const content = modal.querySelector(".modal-window");
  const closeBtn = modal.querySelector("[data-modal-close]");

  const openButtons = document.querySelectorAll("[data-modal-open]");
  const titleEl = modal.querySelector(".modal-title");

  function openModal(title) {

    if (titleEl) {
      titleEl.textContent = title || '';
    }

    modal.classList.remove("hidden");
    modal.classList.add("flex");

    void modal.offsetWidth;

    overlay.classList.remove("opacity-0");
    content.classList.remove("opacity-0", "translate-y-5", "scale-90");

    document.body.classList.add("overflow-hidden");
  }

  function closeModal() {

    overlay.classList.add("opacity-0");
    content.classList.add("opacity-0", "translate-y-5", "scale-90");

    setTimeout(() => {
      modal.classList.add("hidden");
      modal.classList.remove("flex");
    }, 200);

    document.body.classList.remove("overflow-hidden");
  }

  openButtons.forEach(btn => {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      openModal(this.dataset.modalOpen);
    });
  });

  overlay?.addEventListener("click", closeModal);
  closeBtn?.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });
}

// Mobile Reminder

function initMobileReminder() {
  const reminder = document.getElementById("appReminder");
  if (!reminder) return;

  const iosLink = document.getElementById("app-link-ios");
  const androidLink = document.getElementById("app-link-android");
  const closeBtn = reminder.querySelector("button");

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = /android/i.test(userAgent);

  if (isIOS) {
    if (iosLink) {
      iosLink.classList.remove("hidden");
    } else {
      reminder.style.display = "none";
      return;
    }
  }

  else if (isAndroid) {
    if (androidLink) {
      androidLink.classList.remove("hidden");
    } else {
      reminder.style.display = "none";
      return;
    }
  }

  else {
    reminder.style.display = "none";
    return;
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      reminder.style.display = "none";
    });
  }
}

// Form Functional

function initForm() {
  const forms = document.querySelectorAll('.consult-form');

  if (!forms.length) return;

  forms.forEach(form => {
    const nameInput     = form.querySelector('input[name="name"]');
    const phoneInput    = form.querySelector('input[name="phone"]');
    const textInput     = form.querySelector('textarea[name="description"]');
    const serviceSelect = form.querySelector('select[name="service"]');

    if (!nameInput || !phoneInput || !textInput || !serviceSelect) return;

    phoneInput.value = '+380 ';

    function formatPhone(value) {
      let digits = value.replace(/\D/g, '');

      if (digits.startsWith('380')) digits = digits.slice(3);
      digits = digits.substring(0, 9);

      let result = '+380 ';

      if (digits.length > 0) {
        result += '(' + digits.substring(0, 2);
      }

      if (digits.length >= 2) {
        result += ') ' + digits.substring(2, 5);
      }

      if (digits.length >= 5) {
        result += '-' + digits.substring(5, 9);
      }

      return result;
    }

    phoneInput.addEventListener('input', function () {
      this.value = formatPhone(this.value);
    });

    phoneInput.addEventListener('keydown', function (e) {
      const isDelete = e.key === 'Backspace' || e.key === 'Delete';
      if (!isDelete) return;

      const digits = this.value.replace(/\D/g, '');

      if (this.selectionStart === 0 && this.selectionEnd === this.value.length) {
        e.preventDefault();
        this.value = '+380 ';
        return;
      }

      if (this.selectionStart <= 4) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      let clean = digits.startsWith('380')
        ? digits.slice(3)
        : digits;

      clean = clean.slice(0, -1);

      this.value = formatPhone('+380' + clean);
    });

    const isValidName = v =>
      /^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\s'-]{2,}$/.test(v.trim());

    const isValidPhone = v => {
      const clean = v.replace(/\D/g, '');
      return /^380\d{9}$/.test(clean);
    };

    const isValidText = v =>
      v.trim().length >= 2;

    form.addEventListener('submit', async e => {
      e.preventDefault();

      let valid = true;

      [nameInput, phoneInput, textInput].forEach(el =>
        el?.classList.remove('!border-red-500')
      );

      if (!isValidName(nameInput.value)) {
        nameInput.classList.add('!border-red-500');
        valid = false;
      }

      if (!isValidPhone(phoneInput.value)) {
        phoneInput.classList.add('!border-red-500');
        valid = false;
      }

      if (!isValidText(textInput.value)) {
        textInput.classList.add('!border-red-500');
        valid = false;
      }

      if (!valid) return;

      const cleanPhone = phoneInput.value.replace(/\D/g, '');
      const pageUrl = window.location.href;

      const formData = new URLSearchParams({
        action: 'send_to_crm',
        client_name: nameInput.value,
        client_phone: cleanPhone,
        service: "Послуга: " + serviceSelect.value,
        description: textInput.value + "\n\nСторінка: " + pageUrl
      });

      try {

        const response = await fetch(myAjax.ajaxurl, {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: formData
        });

        const result = await response.json();

        if (result.success) {
          const state = form.closest('.consult-state');
          const formBlock = state.querySelector('.consult-form-block');
          const success = state.querySelector('.consult-success');

          formBlock.classList.add('opacity-0');

          setTimeout(() => {
            formBlock.classList.add('hidden');

            success.classList.remove('hidden');

            setTimeout(() => {
              success.classList.remove('opacity-0', 'scale-90');
            }, 10);

          }, 300);
        } else {
          alert('Помилка відправки');
        }

      } catch (err) {
        alert('Помилка зʼєднання');
        console.error(err);
      }
    });
  });
}

// FAQ Functional

function initFAQ() {
  const items = document.querySelectorAll('.faq-item');
  if (!items.length) return;

  items.forEach((item, index) => {

    const trigger = item.querySelector('.faq-trigger');
    const content = item.querySelector('.faq-content');
    const icon = item.querySelector('svg');

    if (index === 0) {
      content.style.height = content.scrollHeight + 'px';
      content.classList.remove('opacity-0');
      content.classList.add('opacity-100');
      icon.classList.add('rotate-180');
    }

    trigger.addEventListener('click', () => {

      const isOpen = content.style.height && content.style.height !== '0px';

      items.forEach(i => {
        const c = i.querySelector('.faq-content');
        const ic = i.querySelector('svg');

        c.style.height = '0px';
        c.classList.remove('opacity-100');
        c.classList.add('opacity-0');

        ic.classList.remove('rotate-180');
      });

      if (!isOpen) {
        content.style.height = content.scrollHeight + 'px';
        content.classList.remove('opacity-0');
        content.classList.add('opacity-100');

        icon.classList.add('rotate-180');
      }
    });
  });
}

// Anchors Functional

function initAnchors() {
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || targetId === '#') return;

    const target = document.querySelector(targetId);
    if (!target) return;

    e.preventDefault();

    const header = document.querySelector('.site-header');
    const offset = header ? header.offsetHeight : 80;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  });
}